export default __webpack_public_path__ + "static/media/leftArrow.9bac0968.svg";